import { render, staticRenderFns } from "./CalendarPlusFill.vue?vue&type=template&id=637fd2ee"
import script from "./CalendarPlusFill.vue?vue&type=script&lang=js"
export * from "./CalendarPlusFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports